/* eslint-disable no-use-before-define */
import React, { useState } from 'react';
import {
  Paper, Box, Typography, Grid, IconButton,
} from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Input from '../../../components/input';
import ButtonTemplate from '../../../components/Button/Button';
import { LoginStore } from '../../../services/zustandProvider';
import { EsqueceuSenhaAPI } from '../../../services/loginAPI';
import { LoginModel } from '../../models';

const useStyles = makeStyles((theme) => ({
  paper: {
    // marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: '#4c5c68 !important',
    padding: 30,
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  ou: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: 'white',
    width: 150,
    height: 6,
    marginTop: 30,
    marginBottom: 30,
  },
}));

interface propsType {
  back: () => void,
  loginData: LoginModel,
  setLoginData: React.Dispatch<React.SetStateAction<LoginModel>>,
}

export default function Forgot({
  back, loginData, setLoginData,
}: propsType):JSX.Element {
  const classes = useStyles();
  const [enviado, setEnviado] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorEmail, setErrorEmail] = useState({
    status: false,
    massage: '',
  });

  async function EnviarEmail() {
    setLoading(true);
    const forgotResponse = await EsqueceuSenhaAPI(loginData.email);
    if (forgotResponse.sucesso) {
      setEnviado(true);
    } else if (forgotResponse.erros[0].propertyName === 'Email') {
      console.log('Email');
      setErrorEmail({ status: true, massage: forgotResponse.erros[0].errorMessage });
    } else {
      console.log('consexão');
      setErrorEmail({ status: true, massage: forgotResponse.erros[0].errorMessage });
    }
    setLoading(false);
  };

  return (
    <>
      {
        !enviado
          ? (
            <Box sx={{ width: '100%' }}>
              <Box
                sx={{
                  mb: 2,
                }}
              >
                <IconButton onClick={back}>
                  <ArrowBackIcon sx={{ color: '#fff', fontSize: '36px' }} />
                </IconButton>
              </Box>
              <Input
                required
                id="E-mail"
                labelSuperior="E-mail"
                name="E-mail"
                placeHolder="E-mail"
                inputColor="white"
                autoFocus
                variant="outlined"
                value={loginData.email}
                onChange={(e: any) => setLoginData((prevState) => (
                  { ...prevState, email: e.target.value }
                ))}
                error={errorEmail.status}
                mensagem={errorEmail.massage}
              />
              {/* <ButtonTemplate variant="none" onClick={() => props.setForgot(false)}>
                <Typography sx={{ color: '#bdbdbd' }}>voltar ao login</Typography>
              </ButtonTemplate> */}
              <Box sx={{ textAlign: 'center' }}>
                <ButtonTemplate
                  style={{ marginLeft: 'auto', marginRight: 'auto' }}
                  type="submit"
                  cor="cyan"
                  tonalidade={800}
                  className={classes.submit}
                  size="large"
                  variante="loading"
                  loading={loading}
                  onClickLoading={() => EnviarEmail()}
                >
                  enviar E-mail
                </ButtonTemplate>
              </Box>
            </Box>
          ) : (
            <Box sx={{ textAlign: 'center' }}>
              <Typography sx={{ color: 'white' }}>
                Enviamos um E-mail com uma
                nova senha para o para o e-mail
                informado, siga as instruções enivadas
                para obter uma nova senha
              </Typography>
              <ButtonTemplate
                style={{ marginLeft: 'auto', marginRight: 'auto' }}
                type="submit"
                cor="cyan"
                tonalidade={800}
                className={classes.submit}
                size="large"
                onClick={back}
              >
                Voltar ao login
              </ButtonTemplate>
            </Box>
          )
    }

    </>
  );
}
